export default function RemoveFromFolderIcon() {
  return (
    <svg viewBox="0 0 18.75 15.38" xmlns="https://www.w3.org/2000/svg">
      <path
        data-name="Path 525"
        d="M18 15.38H.75a.76.76 0 0 1-.75-.76V.75A.76.76 0 0 1 .75 0h6a.21.21 0 0 1 .13.05l2.71 2.63H18a.76.76 0 0 1 .75.75v11.19a.76.76 0 0 1-.75.76M1.69 1.69v12h15.37V4.37H8.91l-2.8-2.68zm5.05 7.69a.18.18 0 0 1-.18-.17v-1a.18.18 0 0 1 .18-.17H12a.18.18 0 0 1 .18.17v1a.18.18 0 0 1-.18.17z"
      />
    </svg>
  );
}
